import { StoreState } from '@/core/models/store.interface';
import { ActionTree, Module } from 'vuex';
import { SendTenantMailTemplate, TenantMailTemplate } from './tenant-mail-template.interface';
import { TenantMailTemplateService } from './tenant-mail-template.service';
import { LocationQuery } from 'vue-router';
const service = new TenantMailTemplateService();

export interface TenantMailTemplateState {
   tenantMailTemplates: Array<TenantMailTemplate>;
}

// create a vuex actionsTree
const actions: ActionTree<TenantMailTemplateState, StoreState> = {
   async getAll({ commit }) {
      const response = await service.getAll();
      commit('SET_TENANT_MAIL_TEMPLATES', response.data);
      return response.data;
   },
   async getFiltered(context, query: LocationQuery) {
      const response = await service.getAll(query);
      return response.data;
   },
   async get(context, id: number) {
      const response = await service.get(id);
      return response.data;
   },
   async send(context, { tenant_mail_template, id }: { tenant_mail_template: SendTenantMailTemplate; id: number }) {
      const response = await service.post(tenant_mail_template, id);
      return response.data;
   },
};

const TenantMailTemplateStore: Module<TenantMailTemplateState, StoreState> = {
   namespaced: true,
   state: {
      tenantMailTemplates: [],
   },
   getters: {},
   mutations: {
      SET_TENANT_MAIL_TEMPLATES(state, tenantMailTemplates: Array<TenantMailTemplate>) {
         state.tenantMailTemplates = tenantMailTemplates;
      },
   },
   actions,
};

export default TenantMailTemplateStore;
